var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "m-5 md:m-15 2xl:m-20",
    on: {
      "keydown": function ($event) {
        return _vm.progressbar.userKeyDown();
      },
      "keyup": function ($event) {
        return _vm.progressbar.userKeyUp();
      },
      "click": _vm.calculate_progress
    }
  }, [_c('h3', {
    staticClass: "mb-5 md:mb-15 2xl:mb-20"
  }, [_vm._v("Autonomie")]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-x-4 gap-y-10"
  }, [_c('div', {
    staticClass: "col-span-full text-base text-indigo-600"
  }, [_vm._v("TEMPS DE TRAVAIL")]), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-6",
    attrs: {
      "name": "temps_travail",
      "libelle": "Temps de travail",
      "necessary": true,
      "value": _vm.form.temps_travail,
      "datas": [{
        value: 'Temps plein'
      }, {
        value: 'Temps partiel'
      }]
    },
    on: {
      "input": function (newValue) {
        _vm.form.temps_travail = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-6",
    attrs: {
      "name": "temps_travail_precis",
      "libelle": "Précisez",
      "necessary": false,
      "value": _vm.form.temps_travail_precis
    },
    on: {
      "input": function (newValue) {
        _vm.form.temps_travail_precis = newValue;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-span-full text-base text-indigo-600 mt-10"
  }, [_vm._v("TRANSPORT")]), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "type_transport",
      "libelle": "Type de transport principal",
      "necessary": true,
      "value": _vm.form.type_transport,
      "datas": [{
        value: 'Bus'
      }, {
        value: 'Tram'
      }, {
        value: 'Voiture'
      }, {
        value: 'Vélo'
      }, {
        value: 'Train'
      }, {
        value: 'Scooter/Moto'
      }]
    },
    on: {
      "input": function (newValue) {
        _vm.form.type_transport = newValue;
      }
    }
  }), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "accompagnateur_transport",
      "libelle": "Accompagnateur",
      "necessary": true,
      "value": _vm.form.accompagnateur_transport,
      "datas": [{
        value: 'Oui'
      }, {
        value: 'Non'
      }]
    },
    on: {
      "input": function (newValue) {
        _vm.form.accompagnateur_transport = newValue;
      }
    }
  }), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "reperage_transport",
      "libelle": "Repérage",
      "necessary": true,
      "value": _vm.form.reperage_transport,
      "datas": [{
        value: 'Oui'
      }, {
        value: 'Non'
      }]
    },
    on: {
      "input": function (newValue) {
        _vm.form.reperage_transport = newValue;
      }
    }
  }), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "place_stationnement_adaptee",
      "libelle": "Place de stationnement adaptée",
      "necessary": true,
      "value": _vm.form.place_stationnement_adaptee,
      "datas": [{
        value: 'Oui'
      }, {
        value: 'Non'
      }]
    },
    on: {
      "input": function (newValue) {
        _vm.form.place_stationnement_adaptee = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "distance_max",
      "libelle": "Précisez la distance max du lieu de stage/travail",
      "necessary": true,
      "value": _vm.form.distance_max
    },
    on: {
      "input": function (newValue) {
        _vm.form.distance_max = newValue;
      }
    }
  }), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "permis",
      "libelle": "Permis de conduire",
      "necessary": true,
      "value": _vm.form.permis,
      "datas": [{
        value: 'Oui'
      }, {
        value: 'Non'
      }]
    },
    on: {
      "input": function (newValue) {
        _vm.form.permis = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "md:col-span-full",
    attrs: {
      "name": "transport_comment",
      "libelle": "Commentaires",
      "necessary": false,
      "value": _vm.form.transport_comment
    },
    on: {
      "input": function (newValue) {
        _vm.form.transport_comment = newValue;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-span-full text-base text-indigo-600 mt-10"
  }, [_vm._v("RESTAURATION")]), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-6",
    attrs: {
      "name": "aides_restauration",
      "libelle": "Aides",
      "necessary": true,
      "value": _vm.form.aides_restauration,
      "datas": [{
        value: 'Aucune aide'
      }, {
        value: 'Aide humaine'
      }, {
        value: 'Aide technique'
      }, {
        value: 'Autre'
      }]
    },
    on: {
      "input": function (newValue) {
        _vm.form.aides_restauration = newValue;
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-in duration-300",
      "enter-class": "opacity-0",
      "leave-active-class": "ease-out duration-300",
      "leave-to-class": "opacity-0"
    }
  }, [_vm.form.aides_restauration == 'Autre' ? _c('input-text', {
    staticClass: "md:col-span-6",
    attrs: {
      "name": "aides_restauration_precis",
      "libelle": "Précisez (si autre)",
      "necessary": true,
      "value": _vm.form.aides_restauration_precis
    },
    on: {
      "input": function (newValue) {
        _vm.form.aides_restauration_precis = newValue;
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('input-text-area', {
    staticClass: "md:col-span-full",
    attrs: {
      "name": "aide_restauration_comment",
      "libelle": "Commentaires",
      "necessary": false,
      "value": _vm.form.aide_restauration_comment
    },
    on: {
      "input": function (newValue) {
        _vm.form.aide_restauration_comment = newValue;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-span-full text-base text-indigo-600 mt-10"
  }, [_vm._v("CONSIGNES")]), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-6",
    attrs: {
      "name": "consignes",
      "libelle": "Consignes",
      "necessary": true,
      "value": _vm.form.consignes,
      "datas": [{
        value: 'Orales'
      }, {
        value: 'Ecrites'
      }, {
        value: 'Donnez des consignes une par une'
      }, {
        value: 'Besoin d\'un rappel de consigne'
      }]
    },
    on: {
      "input": function (newValue) {
        _vm.form.consignes = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-6",
    attrs: {
      "name": "consignes_precis",
      "libelle": "Précisez (dictaphone, support visuel, prise de note)",
      "necessary": false,
      "value": _vm.form.consignes_precis
    },
    on: {
      "input": function (newValue) {
        _vm.form.consignes_precis = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "md:col-span-full",
    attrs: {
      "name": "consignes_comment",
      "libelle": "Commentaires",
      "necessary": false,
      "value": _vm.form.consignes_comment
    },
    on: {
      "input": function (newValue) {
        _vm.form.consignes_comment = newValue;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-span-full text-base text-indigo-600 mt-10"
  }, [_vm._v("COMMUNICATION")]), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-6",
    attrs: {
      "name": "communication",
      "libelle": "Communication",
      "necessary": true,
      "value": _vm.form.communication,
      "datas": [{
        value: 'Bonne élocution en face à face'
      }, {
        value: 'Bonne élocution dans un groupe'
      }, {
        value: 'Elocution difficile mais compense à l\'écrit'
      }, {
        value: 'Communication difficile à l\'écrit comme l\'oral'
      }, {
        value: 'Communication par gestes'
      }]
    },
    on: {
      "input": function (newValue) {
        _vm.form.communication = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "md:col-span-full",
    attrs: {
      "name": "communication_comment",
      "libelle": "Commentaires",
      "necessary": false,
      "value": _vm.form.communication_comment
    },
    on: {
      "input": function (newValue) {
        _vm.form.communication_comment = newValue;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-span-full text-base text-indigo-600 mt-10"
  }, [_vm._v("ECRITURE")]), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-6",
    attrs: {
      "name": "ecriture",
      "libelle": "Ecriture",
      "necessary": true,
      "value": _vm.form.ecriture,
      "datas": [{
        value: 'Manuscrite'
      }, {
        value: 'Dactylographiée'
      }, {
        value: 'Synthèse vocale'
      }, {
        value: 'Limiter la quantité d\'écrits à produire'
      }, {
        value: 'Communication par gestes'
      }]
    },
    on: {
      "input": function (newValue) {
        _vm.form.ecriture = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "md:col-span-full",
    attrs: {
      "name": "ecriture_comment",
      "libelle": "Commentaires",
      "necessary": false,
      "value": _vm.form.ecriture_comment
    },
    on: {
      "input": function (newValue) {
        _vm.form.ecriture_comment = newValue;
      }
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }